// extracted by mini-css-extract-plugin
export default {"list":"QPzI9","link":"aR_bU","imgWrapper":"TgRX9","cnImage":"UFGzc","name":"X5qo4","price":"clPjx","row":"vyAYr"};